import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "tw-w-full tw-pt-6 tw-pb-24" };
const _hoisted_2 = { class: "tw-flex tw-justify-center" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { key: 0 };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check" }, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = {
    class: "tw-w-full tw-rounded tw-items-center tw-align-middle tw-align-center tw-flex-1 tw-mx-3",
    style: { "background-color": "#edf2f7" }
};
import { ref, computed, } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        modelValue: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        const props = __props;
        const currentStep = computed({
            get: () => props.modelValue,
            set(val) {
                emit('update:modelValue', val);
            },
        });
        const steps = ref([
            {
                key: 'type',
                description: 'Device Type',
                actualStep: '',
            },
            {
                key: 'brand',
                description: 'Device Brand',
                actualStep: 'type',
            },
            {
                key: 'model',
                description: 'Device Model',
                actualStep: 'brand',
            },
            {
                key: 'estimate',
                description: 'Estimate',
                actualStep: 'estimate',
            },
        ]);
        const currentStepNumber = computed(() => steps.value.findIndex((m) => m.key === currentStep.value));
        function changeStep(step, index) {
            if (index <= currentStepNumber.value) {
                currentStep.value = step.actualStep;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: step.key,
                            class: _normalizeClass(["tw-flex tw-items-center", [index !== steps.value.length - 1 ? 'tw-w-full' : '']])
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["tw-relative tw-flex tw-flex-col tw-items-center", { 'tw-cursor-pointer': index <= _unref(currentStepNumber) }]),
                                onClick: ($event) => (changeStep(step, index))
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["tw-rounded-full tw-transition tw-duration-500 tw-ease-in-out tw-border-2 tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-border-white tw-py-3 tw-font-bold", [index > _unref(currentStepNumber) ? 'tw-border-primary' : 'tw-text-white tw-bg-primary tw-border-primary']])
                                }, [
                                    (index <= _unref(currentStepNumber))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(index + 1), 1))
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["tw-absolute tw-top-0 tw-text-center tw-mt-12 tw-w-32 m:tw-w-48 tw-font-medium tw-uppercase", [index <= _unref(currentStepNumber) ? 'tw-font-bold' : '']])
                                }, _toDisplayString(step.description), 3)
                            ], 10, _hoisted_3),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                    class: "tw-w-0 tw-py-1 tw-rounded",
                                    style: _normalizeStyle([{ "background-color": "#ff5965" }, { 'width': index <= _unref(currentStepNumber) ? '100%' : '' }])
                                }, null, 4)
                            ])
                        ], 2));
                    }), 128))
                ])
            ]));
        };
    }
});
